<footer class="py-4 bg-footer mt-auto">
    <div class="container-fluid px-4">
        <div class="d-flex align-items-center justify-content-between small flex-wrap gap-3">
            <div class="text-muted">
              Copyright &copy; M.A.L.S 2026 |
              <a routerLink="/impressum" class="impressum-link">{{ 'Legal notice' | t }}</a>
            </div>
            <a class="website-brand" [href]="globals.websiteUrl">
              <img class="website-brand__logo" src="assets/me-logo-mark.png" alt="Mastering Emotions" width="44" height="30">
              <span>Mastering Emotions</span>
            </a>
        </div>
    </div>
</footer>
